import styled from "@emotion/styled";
import BaseButton from "src/atoms/Button/BaseButton";

const EditButtonStyled = styled(BaseButton)`
  border: none;
  background: none;
  cursor: pointer;
`;

export { EditButtonStyled };
